export default {
  getCurrentQuestion: (state) => {
    return state.currentQuestion
  },
  getAnswers: (state) => {
    return state.answers
  },
  getQuestionFlowData: (state) => {
    return state.questionFlowData
  }
}
